export enum MatchTeamTypeEnum {
  Home = "home",
  Away = "away",
}
